import React from "react"
import CalculatorWrapper from "./shared/calculatorWrapper/CalculatorWrapper"
import Units from "./shared/units/Units"
import Gender from "./shared/gender/Gender"
import Weight from "./shared/weight/Weight"
import Age from "./shared/age/Age"
import DailyActivityLevel from "./shared/dailyActivityLevel/DailyActivityLevel"
import PhysicalActivities from "./shared/physicalActivities/PhysicalActivities"
import CalculateButton from "./shared/calculateButton/CalculateButton"
import Height from "./shared/height/Height"

const CalorieCalculator = ({
  handleChangeUnits,
  units,
  handleChangeGender,
  gender,
  handleChangeWeight,
  weight,
  handleChangeAge,
  age,
  handleChangeDailyActivity,
  dailyActivity,
  handleChangeSlider,
  sliderValue,
  handleShowResults,
  handleChangeHeight,
  height,
  locale,
}) => {
  return (
    <CalculatorWrapper locale={locale}>
      <Units
        locale={locale}
        units={units}
        handleChangeUnits={handleChangeUnits}
      />
      <Gender
        locale={locale}
        gender={gender}
        handleChangeGender={handleChangeGender}
      />
      <Weight
        units={units}
        locale={locale}
        handleChangeWeight={handleChangeWeight}
        weight={weight}
      />
      <Height
        units={units}
        locale={locale}
        height={height}
        handleChangeHeight={handleChangeHeight}
      />
      <Age locale={locale} age={age} handleChangeAge={handleChangeAge} />
      <DailyActivityLevel
        locale={locale}
        dailyActivity={dailyActivity}
        handleChangeDailyActivity={handleChangeDailyActivity}
      />
      <PhysicalActivities
        locale={locale}
        handleChangeSlider={handleChangeSlider}
        sliderValue={sliderValue}
      />
      <CalculateButton locale={locale} handleShowResults={handleShowResults} />
    </CalculatorWrapper>
  )
}

export default CalorieCalculator
